var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallbackAnswer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2418_14390)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666016 0.666504H5.21255L6.05638 4.88562L4.27528 6.66672C4.96584 9.10832 6.89087 11.0333 9.33247 11.7239L11.1136 9.94281L15.3327 10.7866V15.3332H11.3327C5.44165 15.3332 0.666016 10.5575 0.666016 4.6665V0.666504ZM1.99935 1.99984V4.6665C1.99935 9.82116 6.17802 13.9998 11.3327 13.9998H13.9993V11.8797L11.5518 11.3902L9.74586 13.1961L9.38621 13.1136C6.16211 12.3734 3.62575 9.83708 2.88561 6.61297L2.80305 6.25333L4.60899 4.44739L4.11948 1.99984H1.99935Z",
    fill: "#697180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.334 1.21196C10.9784 1.21196 9.87944 2.3109 9.87944 3.6665H9.33398C9.33398 2.00965 10.6771 0.666504 12.334 0.666504C13.349 0.666504 14.2458 1.17052 14.7885 1.94128V0.939231H15.334V2.84832H13.4249V2.30287H14.3753C13.9347 1.64476 13.1847 1.21196 12.334 1.21196Z",
    fill: "#16A24A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.334 3.6665C15.334 5.32336 13.9908 6.6665 12.334 6.6665C11.319 6.6665 10.4222 6.1625 9.87944 5.39175V6.39378H9.33398V4.48469H11.2431V5.03014H10.2927C10.7332 5.68824 11.4833 6.12105 12.334 6.12105C13.6896 6.12105 14.7885 5.02211 14.7885 3.6665H15.334Z",
    fill: "#16A24A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.334 1.21196C10.9784 1.21196 9.87944 2.3109 9.87944 3.6665H9.33398C9.33398 2.00965 10.6771 0.666504 12.334 0.666504C13.349 0.666504 14.2458 1.17052 14.7885 1.94128V0.939231H15.334V2.84832H13.4249V2.30287H14.3753C13.9347 1.64476 13.1847 1.21196 12.334 1.21196Z",
    stroke: "#16A24A",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.334 3.6665C15.334 5.32336 13.9908 6.6665 12.334 6.6665C11.319 6.6665 10.4222 6.1625 9.87944 5.39175V6.39378H9.33398V4.48469H11.2431V5.03014H10.2927C10.7332 5.68824 11.4833 6.12105 12.334 6.12105C13.6896 6.12105 14.7885 5.02211 14.7885 3.6665H15.334Z",
    stroke: "#16A24A",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2418_14390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallbackAnswer);
export default __webpack_public_path__ + "static/media/callback_answer.e90e349aff7e16be81b496fab3c0818b.svg";
export { ForwardRef as ReactComponent };